import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  standalone: false,
    selector: 'input-group',
    templateUrl: './input-group.component.html',
})
export class InputGroupWrapperComponent extends FieldWrapper {
}
